import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule, FormsModule],
    selector: 'search-services',
    styleUrls: ['./search-services.scss'],
    templateUrl: './search-services.html',
    standalone: true
})
export class SearchServices implements OnInit {
  appURL: string = environment.appURL;
  search: boolean = false;
  getSearch: string = '';
  getOption: string = '';
  errorSearch: boolean = false;
  errorOption: boolean = false;

  constructor() {}

  ngOnInit() {
  }

  goToSearch() {
    let self = this;
    let keyword = false;
    let option = false;

    // Checks if search keyword value
    if (this.getSearch != '') {
      option = true;
      this.errorSearch = false;
    } else {
      this.errorSearch = true;

      setTimeout(function() {
        self.errorSearch = false;
      }, 5000);
    }

    // Checks if option value
    if (this.getOption != '') {
      keyword = true;
      this.errorOption = false;
    } else {
      this.errorOption = true;

      setTimeout(function() {
        self.errorSearch = false;
      }, 5000);
    }

    // redirect to pages
    if ( keyword && option ) {
      let url = '/' + this.getOption.toLowerCase() + '?query=' + this.getSearch;
      location.href = url;
    }
  }
}